import React, { useMemo } from "react";

import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import zhHant from "antd/es/locale/zh_HK";
import enUS from "antd/es/locale/en_US";
import koKR from "antd/es/locale/ko_KR";
import ar from "antd/es/locale/ar_EG";
import { Locale } from "antd/es/locale";

export interface AntdProviderProps {
    lang: string;
    children?: React.ReactNode;
}
const langMap: Record<string, Locale> = {
    "zh-CN": zhCN,
    "zh-Hant": zhHant,
    "en": enUS,
    "ko-KR": koKR,
    "ar": ar,
};

export const AntdProvider: React.FC<AntdProviderProps> = ({ lang, children }) => {
    const antdLocale = useMemo(() => langMap[lang] ?? langMap["en"], [lang]);
    return (
        <ConfigProvider
            button={{ autoInsertSpace: false }}
            direction={lang === "ar" ? "rtl" : "ltr"}
            getPopupContainer={getPopupContainer}
            // let popups scrolls with container parent
            locale={antdLocale}
        >
            {children}
        </ConfigProvider>
    );
};

function getPopupContainer(trigger?: HTMLElement): HTMLElement {
    return trigger?.parentElement || document.body;
}
